import { Component, inject } from '@angular/core';
import { DialogComponent } from '../dialog/dialog.component';
import { Dialog, IDialogData } from '../dialog';
import { CmsTextProviderService } from '../../../services/cms-text-provider.service';

@Component({
  selector: 'aw-reset-changes-leave-site-dialog',
  imports: [DialogComponent],
  templateUrl: './reset-changes-leave-site-dialog.component.html',
  styles: '',
})
export class ResetChangesLeaveSiteDialogComponent extends Dialog<IDialogData> {
  protected readonly cmsTextProvider: CmsTextProviderService = inject(
    CmsTextProviderService
  );
}
